export var MaintenanceStatus;
(function (MaintenanceStatus) {
    MaintenanceStatus["Due"] = "DUE";
    MaintenanceStatus["Overdue"] = "OVERDUE";
    MaintenanceStatus["NotDue"] = "NOT_DUE";
    MaintenanceStatus["Complete"] = "COMPLETED";
})(MaintenanceStatus || (MaintenanceStatus = {}));
//# sourceMappingURL=maintenanceStatus.enum.js.map